module.exports = __webpack_public_path__ + "img/4.7b9080a1.png";